import React from 'react';
import { ElevatorPage } from '../elevatorPage/ElevatorPage';
import { ElevatorProvider } from '../useElevator/useElevator';

export const ElevatorPageSession = () => {
    return (
        <ElevatorProvider>
            <ElevatorPage/>
        </ElevatorProvider>
    );
};
